import { Link, redirect } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { env } from '@/lib/env';
import { useAuthStore } from '@/store';

export function LoginLoader() {
	const token = useAuthStore.getState().access_token;

	if (token) {
		return redirect('/home');
	}

	return true;
}

export const Login = () => {
	return (
		<div className="flex h-screen w-full items-center justify-center bg-white">
			<Card className="shadow-primary/10 flex h-3/4 flex-row p-0 shadow-lg md:w-3/4">
				<CardContent className="flex w-full flex-col items-center justify-center gap-2 md:w-1/2 md:px-16 lg:px-24">
					<img src="/logo/circle-logo.webp" alt="circle-logo" className="w-40" />
					<h1 className="text-center text-lg font-bold lg:text-xl">Masuk Akun</h1>
					<span className="text-label-input text-center">
						Pastikan email yang Anda masukan benar.
					</span>

					<Button
						type="button"
						className="my-6 w-full"
						onClick={() => {
							const query = new URLSearchParams({
								redirect_uri: env.VITE_DUENDE_REDIRECT_URI,
								response_type: 'code',
								client_id: env.VITE_DUENDE_CLIENT_ID,
								scope: env.VITE_DUENDE_SCOPE,
								code_challenge: env.VITE_DUENDE_CODE_CHALLANGE,
								code_challenge_method: env.VITE_DUENDE_CODE_CHALLANGE_METHOD
							});

							const url = `${env.VITE_DUENDE_URL}/connect/authorize?${query.toString()}`;

							globalThis.location.assign(url);
						}}
					>
						Masuk
					</Button>
					<span className="text-label-input text-sm">
						Belum punya akun?{' '}
						<Link
							to="/register"
							viewTransition
							className="text-primary font-medium underline underline-offset-4"
						>
							Daftar
						</Link>
					</span>
				</CardContent>
				<CardContent className="hidden items-center justify-center rounded-r-xl bg-[url(/image/bg-login.webp)] bg-cover md:flex md:w-1/2">
					<div className="flex h-4/5 w-3/4 flex-col gap-3 rounded-3xl border border-white/50 bg-white/30 px-6 py-6 text-xl font-bold text-white backdrop-blur-xs">
						<span>Platform E-Procurement</span>
						<span>Dari Astra untuk Grup Astra</span>

						<img
							src="/logo/login-1.webp"
							className="absolute -right-12 -bottom-12 size-40 md:size-60 lg:size-80"
							alt="login-1"
						/>
					</div>
				</CardContent>
			</Card>
		</div>
	);
};
